function throwIfMissing() {
  throw new Error('Invalid Profile config: Missing parameter');
}
const validStatus = ['A', 'B', 'N'];

/** Klasse die eine Profilinstanz eines Nutzers repräsentiert. */
export class Profile {
  /**
   * Erstelle ein Profil
   * @param {string} name - Name des Profils
   * @param {number} id - Eindeutige ID des Profils
   * @param {string} status - Bearbeitunsstatus des Profils für den Teilnehmer
   * @param {boolean} isOpen - Profil abgelaufen?
   * @param {boolean} hasActiveComponents - Profil vollständig bearbeitet?
   */
  constructor({
    name = throwIfMissing(),
    id = throwIfMissing(),
    status = throwIfMissing(),
    isOpen = throwIfMissing(),
    hasActiveComponents = throwIfMissing(),
    discoverReportVisible = throwIfMissing(),
  }) {
    if (!validStatus.includes(status)) {
      throw new Error('Invalid Profile config: Unknown status');
    }
    this.name = name;
    this.id = id;
    this.status = status;
    this.isOpen = isOpen;
    this.hasActiveComponents = hasActiveComponents;
    this.discoverReportVisible = discoverReportVisible;
  }

  /**
   * Erfahre, ob das für Profil Ergebnisreportzugriff aktiv ist.
   * @return {boolean} aktiv?
   */
  get hasReportVisible() {
    return this.discoverReportVisible;
  }

  /**
   * Erfahre, ob das Profil aktiv ist.
   * @return {boolean} Profil aktiv?
   */
  get isActive() {
    return this.isOpen && this.hasActiveComponents;
  }

  /**
   * Erfahre, ob das Profil abgeschlossen ist.
   * @return {boolean} Profil abgeschlossen?
   */
  get isCompleted() {
    return this.status === 'A';
  }

  /**
   * Erfahre, ob man das Profil starten kann.
   * Hinweis: derzeit gilt unabhängig vom Status: man kann das Profil starten, solange es offen ist
   * Evt später kann es sein, dass man in ein gesperrtes Profil auch dann navigieren kann, falls es bereits abgeschlossen wurde
   * @return {boolean} Profil "startbar"?
   */
  get canStart() {
    return this.isOpen || this.isCompleted;
  }

  /**
   * Erfahre, ob das Profil gesperrt ist, aber nicht abgeschlossen.
   * @return {boolean} Profil gesperrt?
   */
  get isLocked() {
    return !this.isCompleted && !this.isOpen;
  }

  /**
   * Erfahre, ob das Profil abgeschlossen und nicht aktiv ist.
   * @return {boolean} Profil abgeschlossen?
   */
  get isFinished() {
    return this.isCompleted && !this.isActive; // falls Profil noch offen ist und es noch (nicht-Pflicht)-Komponenten gibt, soll das Profil noch also nicht abgeschlossen angezeigt werden
  }
}
